/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate between text and Morse code. Type a message to encode it into dots and dashes, or paste Morse to decode it.`)
};

const es_mc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduce entre texto y código Morse. Escribe un mensaje para codificarlo en puntos y guiones, o pega Morse para decodificarlo.`)
};

const de_mc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetze zwischen Text und Morsecode. Gib eine Nachricht ein, um sie in Punkte und Striche zu kodieren, oder füge Morse ein, um es zu dekodieren.`)
};

const nl_mc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaal tussen tekst en morsecode. Typ een bericht om het in punten en strepen te coderen, of plak morse om het te decoderen.`)
};

const fr_mc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduisez entre le texte et le code Morse. Tapez un message pour l'encoder en points et tirets, ou collez Morse pour le décoder.`)
};

const it_mc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduci tra testo e codice Morse. Digita un messaggio per codificarlo in punti e trattini, oppure incolla il Morse per decodificarlo.`)
};

const pt_br2_mc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduza entre texto e código Morse. Digite uma mensagem para codificá-la em pontos e travessões, ou cole Morse para decodificá-lo.`)
};

const pt_mc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduza entre texto e código Morse. Digite uma mensagem para codificá-la em pontos e traços, ou cole Morse para decodificá-la.`)
};

const ja_mc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストとモールス信号の間で翻訳します。メッセージを入力してドットとダッシュにエンコードするか、モールス信号を貼り付けてデコードします。`)
};

const zh_mc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在文本和摩尔斯电码之间互译。输入一段文字即可将其编码为点划信号，或粘贴摩尔斯电码将其解码。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_intro", locale)
	if (locale === "en") return en_mc_intro(inputs)
	if (locale === "es") return es_mc_intro(inputs)
	if (locale === "de") return de_mc_intro(inputs)
	if (locale === "nl") return nl_mc_intro(inputs)
	if (locale === "fr") return fr_mc_intro(inputs)
	if (locale === "it") return it_mc_intro(inputs)
	if (locale === "pt-BR") return pt_br2_mc_intro(inputs)
	if (locale === "pt") return pt_mc_intro(inputs)
	if (locale === "ja") return ja_mc_intro(inputs)
	return zh_mc_intro(inputs)
};